module.exports = __webpack_public_path__ + "static/media/slidingBottomImg1.a0eaecdb.png";